import { configureStore } from "@reduxjs/toolkit";
import appCommonSlice from "./reducers/appCommonSlice";
import stringeeClientSlice from "./reducers/stringeeClientSlice";

export const store = configureStore({
  reducer: {
    appCommonSlice: appCommonSlice,
    stringeeClientSlice: stringeeClientSlice,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
